export const GET_UPLOAD_FILE_TYPE_DATA = 'GET_UPLOAD_FILE_TYPE_DATA'
export const GET_UPLOAD_FILE_DATA = 'GET_UPLOAD_FILE_DATA'
export const SET_UPLOAD_FILE_DATA = 'SET_UPLOAD_FILE_DATA'
export const SET_UPLOAD_FILE_TYPE_DATA_STATE = 'SET_UPLOAD_FILE_TYPE_DATA_STATE'
export const SET_UPLOAD_FILE_DATA_STATE = 'SET_UPLOAD_FILE_DATA_STATE'
export const SAVE_CURRENT_UPLOAD_FILE = 'SAVE_CURRENT_UPLOAD_FILE'
export const SAVE_UPLOADED_FILE = 'SAVE_UPLOADED_FILE'
export const DELETE_UPLOADED_FILE = 'DELETE_UPLOADED_FILE'



// WEBPACK FOOTER //
// ./src/vuex/types/common/fileUpload.js